<script lang="ts" setup>

import { onMounted, reactive } from "vue";
import custos from "./custos.json";
import { f2dec } from "@/utils/funcoes";

interface Item {
  mes: number,
  vlrCusto: number,
  qtdeVendas: number,
  qtdeAcum: number,
  vlrLucroMes: number,
  vendasAcum: number,
}

var controle = reactive({
  total: 0,
})

onMounted(() => {

  calcularTotais();
})

function calcularTotais() {
  controle.total = 0;

  custos.forEach(a => {

    controle.total += parseInt(a.qtde ?? "1") * a.valor as number;
  })
}

</script>

<template>
  <div class="card mb-25 border-0 rounded-0 bg-white">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <div class="mb-15 mb-md-30 d-sm-flex align-items-center justify-content-between">
        <h6 class="card-title fw-bold mb-0">Custo Mensal e Total por Vendedor, Doze Meses</h6>
      </div>
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium fs-13 pt-0 ps-0 text-start">
                Descrição
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end">
                Valor R$
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end">
                Quantidade
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end">
                Total R$
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, idx) in custos" :key="idx">
              <tr>
                <td class="shadow-none lh-1 fw-semibold  text-start">
                  {{ item.descricao }}
                </td>
                <td class="shadow-none lh-1 fw-medium  text-end text-black">
                  R$ {{ f2dec(item.valor) }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-end text-black">
                  {{ item.qtde }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-end">
                  R$ {{ f2dec((item.qtde || 0) * (item.valor || 0)) }}
                </td>
              </tr>
            </template>
          </tbody>

          <tfoot>
              <tr>
                <td class="shadow-none lh-1 fw-semibold  text-end">
                  Total
                </td>
                <td class="shadow-none lh-1 fw-medium  text-end text-black">
                </td>
                <td class="shadow-none lh-1 fw-medium text-end text-black">
                </td>
                <td class="shadow-none lh-1 fw-medium text-end">
                  R$ {{ f2dec(controle.total) }}
                </td>
              </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>

